<z-command (zOnSelect)="onItemSelected($event)">
    <z-command-input [placeholder]="placeholder()" [disableInternalFilter]="disableInternalFilter()"
        (valueChange)="onSearchValueChange($event)" [showCloseButton]="showCloseButton()"
        (closeClicked)="onCloseButtonClick()" class="py-2" />

    @if (loading()) {
    <div class="px-4 py-3 text-sm text-gray-500 text-center">Loading...</div>
    } @else {
    <z-command-list class="px-1">
        @if (items().length === 0) {
        <z-command-empty>{{ emptyMessage() }}</z-command-empty>
        } @else if (groupedItems()) {
        @for (group of groupedItems()!; track group.label) {
        <z-command-option-group [zLabel]="group.label">
            @for (item of group.items; track item.id) {
            <z-command-option [zLabel]="item.label" [zIcon]="item.icon" [zValue]="item.id" [zCommand]="item.id"
                [zTimestamp]="item.timestamp" [zTooltip]="item.tooltipDate" />
            }
        </z-command-option-group>
        }
        } @else {
        <z-command-option-group [zLabel]="computedGroupLabel()">
            @for (item of items(); track item.id) {
            <z-command-option [zLabel]="item.label" [zIcon]="item.icon" [zValue]="item.id" [zCommand]="item.id"
                [zTimestamp]="item.timestamp" [zTooltip]="item.tooltipDate" />
            }
        </z-command-option-group>
        }
        @if (showLoadingMore() && searchValue().trim() && isFetchingMore()) {
        <div class="px-4 py-3 text-sm text-gray-500 text-center">{{ loadingMoreMessage() }}</div>
        }
    </z-command-list>
    }
</z-command>
